import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBriefcaseFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M21.81 12.815c.072.04.086.127.09.16v.012l-.08 5.165c0 2.06-1.596 3.74-3.606 3.843l-.196.005H5.972c-2.035 0-3.695-1.616-3.797-3.65l-.005-.198-.07-5.165s0-.121.09-.172c.08-.05.18.01.19.02 2.021 1.357 4.452 2.259 7.004 2.633.36.051.72-.182.82-.546a1.81 1.81 0 0 1 1.623-1.371l.158-.007h.03c.85 0 1.56.547 1.78 1.378.1.364.461.597.821.546 2.552-.374 4.983-1.276 7.004-2.633l.04-.02c.04-.02.1-.03.15 0m-9.815 2.177a.76.76 0 0 0-.743.658l-.007.102v1.306c0 .426.34.76.75.76.385 0 .695-.281.744-.655l.006-.105v-1.306c0-.415-.33-.76-.75-.76M13.285 2c1.501 0 2.732 1.144 2.922 2.613h1.981C20.29 4.613 22 6.344 22 8.47c0 0-.06.9-.08 2.154a.33.33 0 0 1-.13.255c-.48.355-.92.65-.96.67-1.661 1.113-3.591 1.897-5.647 2.287a.32.32 0 0 1-.335-.163 3.3 3.3 0 0 0-2.853-1.649 3.35 3.35 0 0 0-2.872 1.643.32.32 0 0 1-.333.16 15.5 15.5 0 0 1-5.62-2.269l-.96-.668a.29.29 0 0 1-.13-.243C2.05 10.132 2 8.471 2 8.471c0-2.127 1.71-3.858 3.812-3.858h1.97C7.974 3.144 9.205 2 10.705 2Zm0 1.519h-2.58c-.671 0-1.241.466-1.401 1.094h5.382a1.45 1.45 0 0 0-1.4-1.094"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBriefcaseFilled);
export default ForwardRef;
